import React from 'react';
import PropTypes from 'prop-types';

import { ColorPreferenceOptionPropTypes } from 'dpl/shared/utils/customPropTypes';
import FullPageQuizQuestion, {
  FULL_PAGE_QUIZ_QUESTION_VARIANTS
} from 'dpl/components/FullPageQuiz/FullPageQuizQuestion';
import OptionGroup from 'dpl/quiz/option_group/components/OptionGroup';
import OptionGroupOption from 'dpl/quiz/option_group/components/OptionGroupOption';
import { OPTION_GROUP_VARIANTS } from 'dpl/quiz/option_group/utils/constants';

export default function QuizColorQuestion({
  availableColors,
  handleNextClick,
  onPreferenceClick,
  onNoPreferenceClick,
  selectedPreferences,
  inputName
}) {
  const questionOptionProps = {
    type: 'checkbox',
    inputName
  };

  return (
    <div className="AdoptionApplicationQuizColorQuestion">
      <FullPageQuizQuestion
        handleNextClick={handleNextClick}
        title="Choose your color preference"
        subtitle="Select all that apply."
        isValid
        variant={FULL_PAGE_QUIZ_QUESTION_VARIANTS.WIDE}
      >
        <OptionGroup variant={OPTION_GROUP_VARIANTS.RECTANGLE}>
          {availableColors.map(color => (
            <OptionGroupOption
              {...questionOptionProps}
              key={color.id}
              isSelected={selectedPreferences.includes(color.id)}
              title={color.description}
              subtitle={color.details_description}
              value={color.id}
              onSelect={() => onPreferenceClick(color.id)}
            />
          ))}
          <OptionGroupOption
            {...questionOptionProps}
            isSelected={selectedPreferences.length === 0}
            title="No preference"
            subtitle="Any color"
            value=""
            onSelect={onNoPreferenceClick}
          />
        </OptionGroup>
      </FullPageQuizQuestion>
    </div>
  );
}

QuizColorQuestion.propTypes = {
  availableColors: PropTypes.arrayOf(
    PropTypes.shape(ColorPreferenceOptionPropTypes)
  ).isRequired,
  selectedPreferences: PropTypes.arrayOf(PropTypes.number).isRequired,
  handleNextClick: PropTypes.func.isRequired,
  onPreferenceClick: PropTypes.func.isRequired,
  onNoPreferenceClick: PropTypes.func.isRequired,
  inputName: PropTypes.string.isRequired
};
